import Types from "./Types";

/************************************************
searchDisputeAsnRtv
*************************************************/

const searchDisputeAsnRtv = query => {
  return { type: Types.SEARCH_DISPUTE_ASN_RTV, query };
};

const searchDisputeAsnRtvSuccess = searchResult => ({
  type: Types.SEARCH_DISPUTE_ASN_RTV_SUCCESS,
  searchResult
});

const searchDisputeAsnRtvFailure = error => ({
  type: Types.SEARCH_DISPUTE_ASN_RTV_FAILURE,
  error
});
/************************************************
listDisputeReasons
*************************************************/

const listDisputeReasons = query => {
  return { type: Types.LIST_DISPUTE_REASONS, query };
};

const listDisputeReasonsSuccess = disputeReasons => ({
  type: Types.LIST_DISPUTE_REASONS_SUCCESS,
  disputeReasons
});

const listDisputeReasonsFailure = error => ({
  type: Types.LIST_DISPUTE_REASONS_FAILURE,
  error
});

/************************************************
listDisputes
*************************************************/

const listDisputes = query => {
  return { type: Types.LIST_DISPUTES, query };
};

const listDisputesSuccess = disputes => ({
  type: Types.LIST_DISPUTES_SUCCESS,
  disputes
});

const listDisputesFailure = error => ({
  type: Types.LIST_DISPUTES_FAILURE,
  error
});
/************************************************
createDispute
*************************************************/

const createDispute = payload => {
  return { type: Types.CREATE_DISPUTE, payload };
};

const createDisputeSuccess = disputeNr => ({
  type: Types.CREATE_DISPUTE_SUCCESS,
  disputeNr
});

const createDisputeFailure = error => ({
  type: Types.CREATE_DISPUTE_FAILURE,
  error
});

export {
  searchDisputeAsnRtv,
  searchDisputeAsnRtvSuccess,
  searchDisputeAsnRtvFailure,
  createDispute,
  createDisputeSuccess,
  createDisputeFailure,
  listDisputes,
  listDisputesSuccess,
  listDisputesFailure,
  listDisputeReasons,
  listDisputeReasonsSuccess,
  listDisputeReasonsFailure
};



// WEBPACK FOOTER //
// ./src/actions/DisputesActions.js